import LoadingSpinner from './LoadingSpinner';
import { Skeleton } from './ui/skeleton';

interface PageLoaderProps {
  text?: string;
  minHeight?: string;
  variant?: 'spinner' | 'skeleton';
}

function SkeletonLoader() {
  return (
    <div className="container mx-auto px-4 py-8 space-y-6 animate-in fade-in duration-300">
      <div className="space-y-3">
        <Skeleton className="h-10 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="space-y-3">
            <Skeleton className="h-32 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-4/5" />
          </div>
        ))}
      </div>
      
      <div className="space-y-3">
        <Skeleton className="h-64 w-full" />
        <div className="grid grid-cols-2 gap-3">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
        </div>
      </div>
    </div>
  );
}

export default function PageLoader({ 
  text = 'Loading page...', 
  minHeight = 'min-h-[50vh]',
  variant = 'skeleton'
}: PageLoaderProps) {
  if (variant === 'skeleton') {
    return <SkeletonLoader />;
  }
  
  return (
    <div className={`flex items-center justify-center ${minHeight} bg-gray-50/50`}>
      <div className="text-center">
        <LoadingSpinner size="lg" text={text} />
      </div>
    </div>
  );
}